export enum MESSAGE_NAMES {
    PoConfirmed = 'POConfirmed',
    POCancelled = 'POCancelled',
    PORedrafted = 'PORedrafted',
    POCanBePaid = 'POCanBePaid',
    POVersionUpdate = 'POVersionUpdate'
}
